<template>
  <el-button
    class="mg-export-button"
    :class="{ 'is-exporting': !iconType && exporting, 'is-icon-type': iconType }"
    :type="type || 'icon'"
    native-type="button"
    v-bind="$attrs"
    :loading="loading"
    @click.stop="handleExportClick"
  >
    <img v-if="showIcon" class="mg-export-button__icon-img" src="@/assets/common/icon_export_new.png" alt="" />
  </el-button>
</template>

<script>
  export default {
    name: 'MgExportButton',
    props: {
      type: String,
    },
    data() {
      return {
        exporting: false,
        progress: 100,
      }
    },
    computed: {
      iconType() {
        return true
      },
      loading() {
        return this.iconType && this.exporting
      },
      showIcon() {
        return this.iconType && !this.loading
      },
      exportText() {
        return this.exporting ? this.$MGUI?.i18n.t('正在导出') : this.$MGUI?.i18n.t('导出')
      },
      progressStyle() {
        return {
          right: this.progress + '%',
        }
      },
    },
    methods: {
      done() {
        clearTimeout(this.timeId)
        this.progress = 100
        this.exporting = false
      },
      onDownloadProgress({ total = 0, loaded = 0 }) {
        if (total === 0 || this.iconType) return
        this.progress = 100 - Math.floor((loaded / total) * 100)
        if (this.progress > 30) {
          this.timeId = setTimeout(this.onDownloadProgress.bind(this, { total: 100, loaded: loaded + 2 }), 300)
        }
      },
      handleExportClick() {
        if (this.exporting) return
        this.exporting = true
        this.$emit('exporting', this.done)
        this.simulatedProgress(1)
      },
      /**
       * 模拟进度条
       */
      simulatedProgress(progress) {
        if (!this.iconType) {
          this.onDownloadProgress({ total: 100, loaded: progress })
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .mg-export-button {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: auto !important;
    width: auto !important;
    height: auto !important;
    padding: 3px 4px !important;
    border-color: #d2d3d7 !important;
    &.is-icon-type {
      width: var(--mg-op-icon-size, 40px) !important;
      min-width: var(--mg-op-icon-size, 40px) !important;
      height: var(--mg-op-icon-size, 40px) !important;
      min-height: var(--mg-op-icon-size, 40px) !important;
      padding: 0 !important;
      box-sizing: border-box;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }
    &__icon-img {
      width: 20px;
      height: 20px;
      display: block;
      flex-shrink: 0;
    }
    &.is-exporting {
      pointer-events: none;
      color: $mg--color-primary;
      background-color: #ecf1fe;
    }
    &.is-loading {
      color: $mg--color-primary;
      background-color: #ecf1fe;
    }
  }
  :deep(.mg-export-button:hover),
  :deep(.mg-export-button:focus),
  :deep(.mg-export-button:active),
  :deep(.mg-export-button.is-disabled),
  :deep(.mg-export-button.is-disabled:hover),
  :deep(.mg-export-button.is-disabled:focus),
  :deep(.mg-export-button.is-disabled:active) {
    border-color: #d2d3d7 !important;
  }
  :deep(.el-icon-loading) {
    font-size: 20px;
  }
</style>
